import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "@/lib/api";
import { colorForName, initialFromName } from "@/lib/avatar";
import NotificationBell from "@/components/NotificationBell";

export default function Header({ user, current = "" }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try { await logout(); } catch (_e) {}
    navigate("/", { replace: true });
  };

  const color = colorForName(user?.name || user?.email);
  const initial = initialFromName(user?.name || user?.email);
  const isAdmin = user?.email?.toLowerCase() === "convenceme.app@gmail.com";

  return (
    <div className="max-w-4xl mx-auto flex items-center justify-between mb-6">
      <button
        onClick={() => navigate(user ? "/game" : "/")}
        data-testid="home-link"
        className="font-display text-xl md:text-2xl uppercase tracking-tighter"
      >
        Conven<span className="text-[#FF4C4C]">ce</span>me
      </button>

      <div className="flex items-center gap-2 md:gap-3">
        {user && (
          <NotificationBell />
        )}
        {user && isAdmin && (
          <Link
            to="/admin"
            data-testid="header-admin-link"
            className={`cm-press inline-flex items-center gap-1 text-xs font-mono-cm uppercase tracking-widest border-2 border-[#101010] bg-white px-2 sm:px-3 py-1.5 rounded-md cm-shadow-sm ${current === "admin" ? "bg-[#FFDE59]" : ""}`}
          >
            <span>⚙️</span>
            <span className="hidden sm:inline">Admin</span>
          </Link>
        )}
        {user && (
          <Link
            to="/leaderboard"
            data-testid="header-leaderboard-link"
            className={`cm-press inline-flex items-center gap-1 text-xs font-mono-cm uppercase tracking-widest border-2 border-[#101010] bg-white px-2 sm:px-3 py-1.5 rounded-md cm-shadow-sm ${current === "leaderboard" ? "bg-[#FFDE59]" : ""}`}
          >
            <span>🏆</span>
            <span className="hidden sm:inline">Ranking</span>
          </Link>
        )}
        {user && (
          <Link
            to="/profile"
            data-testid="header-profile-link"
            className="cm-press inline-flex items-center gap-2 border-2 border-[#101010] bg-white px-2.5 py-1.5 rounded-md cm-shadow-sm"
          >
            {user?.picture ? (
              <img src={user.picture} alt={user.name} referrerPolicy="no-referrer" className="w-7 h-7 rounded-full border-2 border-[#101010]" data-testid="user-avatar" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
            ) : (
              <span
                className="w-7 h-7 rounded-full border-2 border-[#101010] flex items-center justify-center font-display text-sm"
                style={{ background: color }}
                data-testid="user-avatar"
              >
                {initial}
              </span>
            )}
            <span className="hidden sm:inline font-mono-cm text-xs uppercase tracking-widest" data-testid="user-name">
              {user?.name?.split(" ")[0]}
            </span>
            {user?.play_streak > 0 && (
              <span
                className="font-mono-cm text-[10px] font-bold bg-[#FF4C4C] text-white border border-[#101010] px-1.5 py-0.5 rounded"
                title={`${user.play_streak} día${user.play_streak !== 1 ? "s" : ""} seguidos jugando el reto del día`}
                data-testid="header-streak"
              >
                🔥{user.play_streak}
              </span>
            )}
            {user?.win_streak > 0 && (
              <span
                className="font-mono-cm text-[10px] font-bold bg-[#FFDE59] text-[#101010] border border-[#101010] px-1.5 py-0.5 rounded"
                title={`${user.win_streak} día${user.win_streak !== 1 ? "s" : ""} ganándole a REBECA`}
                data-testid="header-win-streak"
              >
                🏆{user.win_streak}
              </span>
            )}
            {user?.league_tier && (
              <span
                className="font-mono-cm text-[10px] font-bold uppercase tracking-widest bg-white text-[#101010] border border-[#101010] px-1.5 py-0.5 rounded hidden sm:inline"
                title={`Liga ${user.league_tier_label}`}
                data-testid="header-league-tier"
              >
                {user.league_tier === "oro" ? "🥇" : user.league_tier === "plata" ? "🥈" : "🥉"}
                {user.league_tier_label}
              </span>
            )}
            {user?.is_pro && (
              <span className="font-mono-cm text-[10px] uppercase tracking-widest bg-[#FFDE59] border border-[#101010] px-1.5 py-0.5 rounded" data-testid="header-pro-badge">
                PRO
              </span>
            )}
          </Link>
        )}
        {user && (
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="cm-press text-xs font-mono-cm uppercase tracking-widest border-2 border-[#101010] bg-white px-2 py-1.5 sm:px-3 rounded-md cm-shadow-sm"
          >
            <span className="hidden sm:inline">Salir</span>
            <span className="sm:hidden">✕</span>
          </button>
        )}
      </div>
    </div>
  );
}
